import { createI18n } from 'vue-i18n';
import es from '@/locales/es.json';
import en from '@/locales/en.json';

// Obtener el idioma guardado o usar español por defecto
const savedLanguage = localStorage.getItem('userLanguage') || 'es';

export const i18n = createI18n({
  legacy: false,
  locale: savedLanguage,
  fallbackLocale: 'en',
  messages: {
    es,
    en
  }
});
